"use strict";

exports.__esModule = true;
exports.consentChecker = void 0;

const consentChecker = (message, consentInfo) => {
  if (consentInfo && consentInfo.requiredFlags && consentInfo.sensitiveProperties) {
    const {
      requiredFlags,
      sensitiveProperties
    } = consentInfo;
    let processedMessage = {};

    const conditionChecker = (result, flag) => {
      return result !== false ? message[flag] === true ? true : false : false;
    };

    const hasPassedConsentChecks = requiredFlags.reduce(conditionChecker, true);
    const keys = Object.keys(message);
    keys.map(key => sensitiveProperties.findIndex(k => k == key) !== -1 && !hasPassedConsentChecks ? processedMessage[key] = 'no-consent' : processedMessage[key] = message[key]);
    return processedMessage;
  }

  return message;
};

exports.consentChecker = consentChecker;